import React from "react";
import "./ToolCard.css";
import Underline from "../Underline/Underline";

const ToolCard = ({ tool }) => {
  return (
    <div className="toolcard-container">
      {/* Left Side — Text Content */}
      <div className="toolcard-text">
        <Underline heading={tool.title} />

        {tool.description?.heading && (
          <section>
            <h2 className="tool-subheading">{tool.description.heading}</h2>
            <p className="tool-paragraph">{tool.description.text}</p>
          </section>
        )}

        {tool.features?.heading && tool.features?.list && (
          <section>
            <h2 className="tool-subheading">{tool.features.heading}</h2>
            <ul className="tool-list">
              {tool.features.list.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </section>
        )}

        {tool.benefits?.heading && tool.benefits?.list && (
          <section>
            <h2 className="tool-subheading">{tool.benefits.heading}</h2>
            <ul className="tool-list">
              {tool.benefits.list.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </section>
        )}

        {tool.pdf?.heading && tool.pdf?.url && (
          <section className="tool-pdf-section">
            <h2 className="tool-subheading">{tool.pdf.heading}</h2>
            <div className="button_holder">
              <a
                className="timeline_link"
                href={`${window.location.origin}${tool.pdf.url}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View PDF&nbsp;&nbsp;&nbsp;
                <span className="fa fa-angle-double-right double_arrow"></span>
              </a>
            </div>
          </section>
        )}
      </div>

      {/* Right Side — Image */}
      {tool.image && (
        <div className="toolcard-image-container">
          <img src={tool.image} alt={tool.title} className="toolcard-image" />
        </div>
      )}
    </div>
  );
};

export default ToolCard;
